export const getFullName = (firstName?: string, lastName?: string): string =>
  `${firstName ? `${firstName} ` : ''}${lastName ?? ''}`;

export const getStyledTopMatterContainerMaxWidth = (
  pathname?: string,
  hasBrandEngineFeature: boolean = false
): string => {
  let maxWidth = '632';

  if (hasBrandEngineFeature) {
    if (pathname?.includes('/modify')) {
      maxWidth = '568';
    } else if (pathname?.includes('/booking')) {
      maxWidth = '1024';
    } else {
      maxWidth = '600';
    }
  }

  return maxWidth + 'px';
};
